import React, { useState, useEffect } from "react";
import { Layout, Space, PageHeader, message, Radio } from "antd";
import R2Footer from "../../components/Footer";
import EmployeeService from "../../services/EmployeeService";
import "./Delivery.scss";
import DeliverySettingsContent from "./DeliverySettingsContent";
import DriverService from "../../services/DriverService";
import { useSelector } from "react-redux";

const { Content } = Layout;

const DeliverySettings = () => {
  const [selectedCategory, setSelectedCategory] = useState("orders");
  const [zoneCatering, setZoneCatering] = useState([]);
  const [zoneOrders, setZoneOrders] = useState([]);
  const [employees, setEmployees] = useState([]);
  const adminRestaurant = useSelector((state) => state.admin);

  const deleteEmployee = async (id) => {
    try {
      await EmployeeService.deleteEmployee(id);
      setEmployees((employees) => employees.filter((e) => e.id !== id));
    } catch (error) {
      message.error(
        "Error creating employee. Please check your input and try again."
      );
    }
  };

  useEffect(() => {
    if (adminRestaurant) {
      // setSelectedRestaurant(adminRestaurant)
      getZone(adminRestaurant);
    }
  }, [adminRestaurant]);

  const getZone = async (id) => {
    const data = await DriverService.getDeliveryZone(id);
    if (data?.delivery_zones) {
      const deliveryZone = data?.delivery_zones.filter(
        (item) => item.restaurant_id === adminRestaurant
      );
      setZoneCatering(deliveryZone.filter((item) => item.is_catering === true));
      setZoneOrders(deliveryZone.filter((item) => item.is_catering === false));
    }
  };

  const addZone = async (paylod) => {
    const dataPayload = {
      is_catering: selectedCategory === "orders" ? false : true,
      ...paylod,
    };
    await DriverService.addDeliveryZone(dataPayload);
    getZone(adminRestaurant);
  };
  const deleteZone = async (id) => {
    await DriverService.deleteDeliveryZone(id);
    getZone(adminRestaurant);
  };

  const updateZone = async (paylod, id) => {
    const dataPayload = {
      is_catering: selectedCategory === "orders" ? false : true,
      ...paylod,
    };
    await DriverService.updateDeliveryZone(dataPayload, id);
    getZone(adminRestaurant);
  };

  return (
    <Layout className="u-page-layout">
      <Content>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
            title="Delivery Settings"
            className="page-header"
            extra={[
              <div className="text-left">
                <Radio.Group
                  value={selectedCategory}
                  size="large"
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  <Radio.Button value="orders">Orders</Radio.Button>
                  <Radio.Button value="catering">Catering</Radio.Button>
                </Radio.Group>
              </div>,
            ]}
          />

          <DeliverySettingsContent
            selectedCategory={selectedCategory}
            addZone={addZone}
            zones={selectedCategory === "orders" ? zoneOrders : zoneCatering}
            deleteZone={deleteZone}
            updateZone={updateZone}
          />
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

export default DeliverySettings;
